import React from "react";

const TextArea = ({ name, label, value, onChange, cols, rows }) => {
  return (
    <div className="form-group">
      <label htmlFor="comments">{label}</label>
      <textarea
        className="form-control"
        name={name}
        id={name}
        value={value}
        onChange={onChange}
        cols={cols ? cols : 70}
        rows={rows ? rows : 5}
      ></textarea>
    </div>
  );
};

export default TextArea;
